import * as React from 'react';
import { useModule } from '../../../hooks/module/module';
import { ShowContentManageClassProvider } from '../context/content-context';
import { Background } from './layout-styled';
import { LayoutFooter } from './layout/footer/footer';
import { LayoutHeader } from './layout/header/header';

export const Layout = ({ children, showFooter }) => {
  const { moduleSelected } = useModule();

  return (
    <section>
      <Background gradientColor={moduleSelected?.settingsMap?.primaryColor}>
        <ShowContentManageClassProvider>
          <LayoutHeader />
          {children}
          {showFooter && <LayoutFooter />}
        </ShowContentManageClassProvider>
      </Background>
    </section>
  );
};
